var _rect, _rect2, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSet2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4,
    fill: "#FCEFDB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 32,
    height: 32,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0526 32.4211H33.8C34.9201 32.4211 35.4802 32.4211 35.908 32.2031C36.2843 32.0113 36.5903 31.7054 36.782 31.329C37 30.9012 37 30.3412 37 29.2211V19.2C37 18.0799 37 17.5198 36.782 17.092C36.5903 16.7157 36.2843 16.4097 35.908 16.218C35.4802 16 34.9201 16 33.8 16H16.2C15.0799 16 14.5198 16 14.092 16.218C13.7157 16.4097 13.4097 16.7157 13.218 17.092C13 17.5198 13 18.0799 13 19.2V29.2211C13 30.3412 13 30.9012 13.218 31.329C13.4097 31.7054 13.7157 32.0113 14.092 32.2031C14.5198 32.4211 15.0799 32.4211 16.2 32.4211H19.9474",
    stroke: "#212134",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0547 24.8398L24.1234 30.9085C24.686 31.4711 25.0021 32.2342 25.0021 33.0299V34.9451M18.0547 24.8398H20.581M18.0547 24.8398V27.3662",
    stroke: "#212134",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9453 24.8398L25.8766 30.9085C25.314 31.4711 24.9979 32.2342 24.9979 33.0299V34.9451M31.9453 24.8398H29.419M31.9453 24.8398V27.3662",
    stroke: "#212134",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0041 19.793V33.0561M25.0041 19.793L23.1094 21.6877M25.0041 19.793L26.8988 21.6877",
    stroke: "#212134",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSet2);
export default __webpack_public_path__ + "static/media/set2.f1ffcb8950cdee09e3be7a83c6dd0ed6.svg";
export { ForwardRef as ReactComponent };